




/**
 * #Switch Color
Change la couleur du body – La couleur par défaut est conservée, au scroll jusqu'à l'élément ensuite c'est la couleur de l'attribut **data-switchcolor-color** qui est injectée dans le body **<data-switchcolor-target>** par défaut le body

```
    <div data-switchcolor-color="var(--marron-clair)" data-switchcolor-target=".container"/> 
    </div>
```
 */
class Switchcolor{

    constructor(el, index){
        this.DOM = el;
        this.index = index
        this.color = el.dataset.switchcolorColor;
        this.target = document.querySelector(`${el.dataset.switchcolorTarget}`) || document.body
        this.initialColor = window.getComputedStyle(this.target).backgroundColor
        
        this.offset = window.innerHeight / 2 

        document.addEventListener('scroll', ()=> this.change())
    }
    change(){
        if((this.DOM.offsetTop - this.offset) < scrollY) {
            // console.log("passe");
            this.target.style.backgroundColor = this.color;
            document.body.classList.add(`switchcolor-${this.index}`)
        }else{
            // console.log("audessus");
            this.target.style.backgroundColor = this.initialColor;
            document.body.classList.remove(`switchcolor-${this.index}`)
        }
    }

    static bind(){

        this.elements = document.querySelectorAll('[data-switchcolor-color]')
        this.elements && this.elements.forEach((el, index) => new Switchcolor(el, index))
    }
}


window.addEventListener('DOMContentLoaded', Switchcolor.bind())